// extracted by mini-css-extract-plugin
module.exports = {"button":"FJUpgradeButton_button__2rmEc"};